import React, { useState } from "react";
import profile from "../../assets/img/temp/profile.png";
import like from "../../assets/img/icons/like.svg";
import arrow from "../../assets/img/icons/arrow-down.svg";
import CommentReply from "./CommentReply";
import moment from "jalali-moment";
const CommentBox = ({ info, setShowCommentModa }) => {
  const [expand, setExpand] = useState(false);
  console.log(info);
  return (
    <div className="CommentBox mt-[40px]">
      <div className="CommentBox__header">
        <div className="flex items-center">
          <img src={profile} className="CommentBox__header--profile " />
          <div>
            <p className="font-[500] text-[14px] text-[#292D32] ">
              {info.username && info.username}
            </p>
            <p className="font-[400] text-[12px] text-[#797D82] ">
              منتشر شده در{" "}
              <span>{info.created_at}</span>{" "}
            </p>
          </div>
        </div>
        <div className="flex items-center">
          <button className="gray-button">پاسخ</button>
          <div className="flex items-center CommentBox__header--like">
            <img src={like} />
            <p className="font-[500] text-[14px] text-[#B5B9BE] mr-[6px] mb-[-4px]">
              {info.like_count}
            </p>
          </div>
        </div>
      </div>
      <hr />
      <p className="font-[400] text-[18px] text-[#292D32] mb-[20px]">
        {info.body}
      </p>
      {info.answer_comments.length > 0 &&
        <div
          className="flex items-center cursor-pointer"
          onClick={() => setExpand(!expand)}
        >
          {expand
            ? <p className="font-[700] text-[14px] text-[#00A6A6] ml-[7px]">
                مخفی کردن پاسخ
              </p>
            : <p className="font-[700] text-[14px] text-[#00A6A6] ml-[7px]">
                {" "}نشان دادن پاسخ
              </p>}
          <img
            src={arrow}
            className={`${expand
              ? "CommentBox_arrow-expand"
              : "CommentBox_arrow"}`}
          />
        </div>}
      <div
        className={`${expand ? "replyCommentBox_expand" : "replyCommentBox"}`}
      >
        {info.answer_comments.map(i => <CommentReply info={i} />)}
      </div>
    </div>
  );
};

export default CommentBox;
